// extracted by mini-css-extract-plugin
module.exports = {"content":"PresentationLayout_content__VAnf3","iframe-content":"PresentationLayout_iframe-content__3xJWy"};